import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import SEO from './components/SEO';
import { SecurityProvider } from './components/SecurityProvider';
import SecurityWarnings from './components/SecurityWarnings';
import ProtectedRoute from './components/ProtectedRoute';
import ProtectedStudentRoute from './components/ProtectedStudentRoute';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import CourseFeatures from './components/CourseFeatures';
import CurrentCourses from './components/CurrentCourses';
import SuccessBanner from './components/SuccessBanner';
import Testimonials from './components/Testimonials';
import ImpressumPage from './pages/ImpressumPage';
import RegistrationPage from './pages/RegistrationPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import StudentLoginPage from './pages/StudentLoginPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import { StudentAuthProvider } from './contexts/StudentAuthContext';
import StudentDashboardLayout from './pages/student/StudentDashboardLayout';
import StudentDashboardHome from './pages/student/StudentDashboardHome';
import StudentAnnouncementsPage from './pages/student/StudentAnnouncementsPage';
import StudentLearningAppPage from './pages/student/StudentLearningAppPage';
import StudentProfilePage from './pages/student/StudentProfilePage';
import StudentCoursePage from './pages/student/StudentCoursePage';
import StudentCourseLessonsPage from './pages/student/StudentCourseLessonsPage';
import StudentWatchPage from './pages/student/StudentWatchPage';
import StudentCertificatesPage from './pages/student/StudentCertificatesPage';
import StudentPaymentsPage from './pages/student/StudentPaymentsPage';
import NotFoundPage from './pages/NotFoundPage';
import SessionWarningModal from './components/SessionWarningModal';
import ArabischLernenPage from './pages/ArabischLernenPage';
import ArabischAlphabetPage from './pages/ArabischAlphabetPage';
import QuranArabischPage from './pages/QuranArabischPage';

const HomePage = () => (
  <>
    <SEO />
    <Header />
    <Hero />
    <CourseFeatures />
    <SuccessBanner />
    <About />
    <CurrentCourses />
    <Testimonials />
    <FAQ />
    <Contact />
    <Footer />
  </>
);

export function AppRoutes() {
  return (
    <SecurityProvider>
      <ScrollToTop />
      <SecurityWarnings />
      <SessionWarningModal />
      <div className="min-h-screen bg-white">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/datenschutz" element={<PrivacyPolicyPage />} />
          <Route path="/agb" element={<TermsOfServicePage />} />
          <Route path="/anmelden" element={<RegistrationPage />} />
          <Route path="/arabisch-lernen" element={<ArabischLernenPage />} />
          <Route path="/arabisch-alphabet-lernen" element={<ArabischAlphabetPage />} />
          <Route path="/quran-arabisch-lernen" element={<QuranArabischPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboardPage />
              </ProtectedRoute>
            }
          />
          <Route path="/login" element={<StudentAuthProvider><StudentLoginPage /></StudentAuthProvider>} />
          <Route path="/reset-password" element={<StudentAuthProvider><ResetPasswordPage /></StudentAuthProvider>} />
          <Route
            path="/dashboard"
            element={
              <StudentAuthProvider>
                <ProtectedStudentRoute>
                  <StudentDashboardLayout />
                </ProtectedStudentRoute>
              </StudentAuthProvider>
            }
          >
            <Route index element={<StudentDashboardHome />} />
            <Route path="ankuendigungen" element={<StudentAnnouncementsPage />} />
            <Route path="lernapp" element={<StudentLearningAppPage />} />
            <Route path="zertifikate" element={<StudentCertificatesPage />} />
            <Route path="zahlungen" element={<StudentPaymentsPage />} />
            <Route path="profil" element={<StudentProfilePage />} />
            <Route path="kurse/:id" element={<StudentCoursePage />} />
            <Route path="kurse/:id/lektionen" element={<StudentCourseLessonsPage />} />
            <Route path="kurse/:id/lektion/:recordingId" element={<StudentWatchPage />} />
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </SecurityProvider>
  );
}
